import React, { Component } from "react";

import { FormPage } from "./components/FormPage";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  Navigate,
} from "react-router-dom";

import "./Main.css";

export default class App extends Component {
  displayName = App.name;

  render() {
    return (
      <FormPage/>
      // <Routes>
      //   <Route path="/FormPage" element={<FormPage />} />
      //   <Route path="*" element={<Navigate to="/FormPage" />} />
      // </Routes>
    );
  }
}